import axios from "axios"
import { BACKEND } from "../../config/configEnvs"
import { toast } from "react-toastify"

export const HandleUpdateItem = async ({route, id, field, value}) => {
  try {

    if (!id) {
      throw new Error("ID no definido");
    }
    if (!Array.isArray(value)) {
      throw new Error("El valor enviado no es un array");
    }

    await axios.put(`${BACKEND}/api/${route}/${id}`, {
      [field]: value
    })
    toast.success("Actualizado con éxito")
  } catch (e) {
    console.log(e)
    toast.error("Error al actualizar: " + e)
  }
}